export const genders = [
  {
    he: "זכר",
    en: "male",
  },
  {
    he: "נקבה",
    en: "female",
  },
  {
    he: "אחר",
    en: "else",
  },
];
